import React, { FunctionComponent, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all_with_count, fetch_one, fetch_all } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import LockIcon from '@mui/icons-material/Lock';
import PostAddIcon from '@mui/icons-material/PostAdd';

import {
  Alert,
  Button as Btn,
  DialogActions,
  Divider,
  Grid,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  Button,
  DataGrid,
  DateAndTimePicker,
  Dt,
  Editor,
  IconButton,
  Page,
  Typography
} from '../../../components/v2/styled';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { KnowledgeCourse } from '../../../models/KnowledgeCourse';
import { User } from '../../../models/User';

import HelpersPractice from '../../../actions/helpers/practice';
import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';
import { KnowledgeSubscription } from '../../../models/KnowledgeSubscription';
import { Base } from '../../../components/v2/dialogs/Base';

import HelpersLanguage from '../../../actions/helpers/language';
import Visibility from '@mui/icons-material/Visibility';
import Schedule from '@mui/icons-material/Schedule';
import Delete from '@mui/icons-material/Delete';
import { SnackDestroyed } from '../../../components/v2/snacks/Destroyed';
import Settings from '@mui/icons-material/Settings';

const { DateTime } = require("luxon");

type Props = {}

export const CoachUserCourses: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const params = useParams();
  const {t, i18n} = useTranslation(['translations']);

  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  let count = 0;
  let count2 = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("id DESC");
  const [page2, setPage2] = useState<number>(0);
  const [order2, setOrder2] = useState<string>("id DESC");
  const [search, setSearch] = useState<string>("");
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [activeDialog, setActiveDialog] = useState<KnowledgeSubscription>();
  const [approvalMessage, setApprovalMessage] = useState<string>("");
  const [newEnds, setNewEnds] = useState<string>();
  const [showProgress, setShowProgress] = useState<KnowledgeSubscription>();
  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);

  // let is_elearning = HelpersPractice.practice_modules_v3({practice: currentPractice, check: 'elearning'});
  let is_elearning = true;

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["user", 'short', (login?.practice_id || currentPractice?.id), objectId],
    queryFn: () =>
      fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user',
          id: objectId,
          fields: [
            'id', 'first_name', 'last_name', 'consent_status'
          ],
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    // select: (d) => {
    //   return {
    //     ...d,
    //     birth_date: DateTime.fromISO(d.birth_date).toFormat("dd/LL/y")
    //   };
    // },
    enabled: !!(login?.practice_id || currentPractice?.id) && parseInt(objectId || '', 10) > 0,
  });

  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["coach", "knowledge_subs", objectId, {page: page, order: order, search: search}],
    queryFn: () =>
      fetch_all_with_count<KnowledgeSubscription>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_subscription',
          fields: ['id', 'created_at', 'lesson_key', 'last_activity', 'approved_at', 'is_approved', 'knowledge_course', 'progress'],
          sub_fields: {
            practice: ['id', 'name', 'get_item'],
            knowsub: ['id', 'created_at', 'lesson_key', 'last_activity', 'approved_at', 'is_approved'],
            knowledge_course: ['id', 'name', 'full_name', 'full_teaser', 'extra_data', 'get_item', 'is_bg_color', 'practice', 'mollie_data']
          },
          order: order,
          per_page: 200,
          page: page,
          filter: {
            search: search,
            advanced: {
              user_id: objectId,
              practice_id: (login?.practice_id || currentPractice?.id),
            }
          },
          for_client: objectId,
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!(login?.practice_id || currentPractice?.id) && parseInt(objectId || '', 10) > 0 && !!is_elearning,
  });
  const {
    data: knowledgeCourses,
    isLoading: knowledgeCoursesLoading,
    // isError: objectsError,
    // isSuccess: objectsSuccess,
    refetch: knowledgeCoursesRefetch,
  } = useQuery({
    queryKey: ["coach", "knowledge_courses_short", (login?.practice_id || currentPractice?.id)],
    queryFn: () =>
      fetch_all_with_count<KnowledgeCourse>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_course',
          fields: ['id', 'name'],
          order: order,
          per_page: 200,
          page: page,
          filter: {
            search: search,
            advanced: {
              practice_id: (login?.practice_id || currentPractice?.id),
            }
          },
        },
        login
      ),
    select: (d) => {
      count2 = d.count;
      return d.result;
    },
    enabled: !!(login?.practice_id || currentPractice?.id) && !!is_elearning,
  });






  const mutationCustomAction2 = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{custom_result: {success?: boolean;}}>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setApprovalMessage("");
      setDialogOpen(false);
      setNewEnds(undefined);
      objectsRefetch();
    },
  });
  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{custom_result: {success?: boolean;}}>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      objectsRefetch();
      knowledgeCoursesRefetch();
      // questionnairesRefetch();
    },
  });
  const mutationDestroy = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<KnowledgeSubscription>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setDestroyedOpen(true);
      objectsRefetch();
    },
  });









  const selectContentWithId = (field?:{[z:string]: string}, extraFallback?:string) => {
    let correct = (field || {})[HelpersLanguage.mapping_to_id(i18n.resolvedLanguage || 'nl')];
    if (!!correct) return correct;
    let fallback = (field || {})['nl'];
    if (!!fallback) return fallback;
    let anyFallback = Object.values(field || {}).filter(fff => !!fff)[0];
    if (!!anyFallback) return anyFallback;
    if (!!extraFallback) return extraFallback;
    return t("general.translation_fallbacks.no_translation_available")
  }

  const columns: GridColDef[] = [
    // { field: 'id', headerName: 'ID', width: 80 },
    { field: 'course_name', headerName: t("coach.models.knowledge_courses.name"), width: 200 },
    { field: 'knowsub_created_at', headerName: t("coach.models.knowledge_courses.invited_at", "Invited"), width: 250, renderCell: params => <>
      {!!params.row.knowsub_created_at && <Dt d={params.row.knowsub_created_at} f="DDD t" />}
    </> },
    { field: 'knowsub_last_activity', headerName: t("coach.models.knowledge_courses.last_activity", "Last activity"), width: 250, renderCell: params => <>
      {!!params.row.knowsub_last_activity && <Dt d={params.row.knowsub_last_activity} f="DDD t" />}
    </> },
    { field: 'approve_status', headerName: t("coach.models.knowledge_courses.approval", "Approval"), width: 250, renderCell: params => <>
      {!!params.row.knowsub?.approved_at && <Dt d={params.row.knowsub.approved_at} f="DDD t" />} {!!params.row.knowsub?.is_approved && !!params.row.knowsub?.approved_at && <Check sx={{marginBottom: -1}} />}{!params.row.knowsub?.is_approved && !!params.row.knowsub?.approved_at && <Close sx={{marginBottom: -1}} />}
    </> },
    { field: 'progress', headerName: t('coach.models.knowledge_subscriptions.progress'), width: 120, renderCell: params => <>
      {!!params.row.progress?.lessons && <Visibility sx={{marginRight: 1, color: theme.palette.primary.main, marginBottom: -1, cursor: 'pointer'}} onClick={() => {
        setShowProgress(params.row);
      }} />}
      <Typography variant="caption" sx={{fontStyle: 'italic'}}>{params.row.progress?.lessons}</Typography>
    </> },
  ];
  const columns2: GridColDef[] = [
    // { field: 'id', headerName: 'ID', width: 80 },
    { field: 'course_name', headerName: t("coach.models.knowledge_courses.name"), width: 200 },
  ];

  return <Page
    title={t("coach.menu.knowledge_courses")}
    titleCrumbs={[
      {
        title: t("coach.menu.users", "Cliënten"),
        path: "/users"
      },
      {
        title: !!object?.first_name ? [object?.first_name, object?.last_name].join(" ") : 'Cliënt',
        path: `/user/${object?.id}/detail`
      }
    ]}
  >
    <DataGrid
      action_count={1}
      // hideCount
      actions={(params) => {
        return (<>
          {/* <IconButton title={t("coach.knowledge_courses.actions.invite", "Invite")} color="default" onClick={() => {
            mutationCustomAction.mutate({
              formData: {
                object: 'questionnaire_result',
                class_action: 'custom_api_create_and_send_invite',
                user_id: objectId,
                questionnaire_id: params.row.questionnaire_id,
                practice_id: currentPractice?.id
              }
            });
          }}>
            <PostAddIcon />
          </IconButton> */}
          <IconButton title="View" color="default" onClick={() => {
            setDialogOpen(true);
            setActiveDialog(params.row);
          }}>
            <Settings />
          </IconButton>
        </>);
      }}
      objectCount={count}
      getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
      objects={(objects || []).map(u => ({
        ...u,
        course_name: u?.knowledge_course?.name,
        practice_name: u.knowledge_course?.practice?.name,
        knowsub_created_at: u.created_at,
        knowsub_last_activity: u.last_activity,
        knowsub: u
      }))}
      columns={columns}
      loader={objectsLoading}
      onSortModelChange={(a, b) => {
        let a_0_field:string = a[0].field;
        if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
        setOrder([a_0_field, a[0].sort].join(' '));
      }}
      page={page}
      setPage={(p) => {setPage(p);}}
    />

    <DataGrid
      action_count={1}
      hideCount
      actions={(params) => {
        return (<>
          <IconButton title={t("coach.knowledge_courses.actions.invite", "Invite")} color="default" onClick={() => {
            mutationCustomAction.mutate({
              formData: {
                object: 'knowledge_course',
                class_action: 'custom_api_subscribe',
                user_id: objectId,
                id: params.row.id,
                as_coach: 1
              }
            });
          }}>
            <PostAddIcon />
          </IconButton>
        </>);
      }}
      objectCount={count2}
      getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
      objects={(knowledgeCourses || []).filter(fff => (objects || []).map(mm => mm.knowledge_course?.id).indexOf(fff.id) < 0).map(u => ({
        ...u,
        course_name: u?.name,
      }))}
      columns={columns2}
      loader={knowledgeCoursesLoading || objectsLoading}
      onSortModelChange={(a, b) => {
        let a_0_field:string = a[0].field;
        // if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
        setOrder2([a_0_field, a[0].sort].join(' '));
      }}
      page={page2}
      setPage={(p) => {setPage2(p);}}
      sx={{
        marginTop: 2
      }}
    />

    <SnackDestroyed open={destroyedOpen} setOpen={setDestroyedOpen} />

    <Base
      name="approval_flow"
      hidden={!dialogOpen}
      title={t("coach.dialogs.knowledge_approval_and_settings.title")}
      content={<Grid container spacing={1}>
        {!!activeDialog?.approved_at && <>
          {/* nieuw einde instellen, newEnds */}
          <Grid item xs={12}>
            <Typography sx={{
              fontSize: '0.7rem'
            }}>{t("coach.models.knowledge_subscriptions.new_end_time")} *</Typography>
            <DateAndTimePicker
              disableFuture={false}
              disablePast
              id="new_end_time"
              value={newEnds || (!!activeDialog.ends_at ? DateTime.fromISO(activeDialog.ends_at).toFormat("dd/LL/y t") : undefined) || DateTime.now().plus({years: 1}).toFormat("dd/LL/y t")}
              setValue={(e) => {
                setNewEnds(e);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              label={t("coach.models.knowledge_subscriptions.change_ends_at")}
              id='change_ends_at'
              disabled={mutationCustomAction.isPending}
              contained
              startIcon={<Schedule />}
              onClick={(v) => {
                mutationCustomAction.mutate({
                  formData: {
                    object: 'knowledge_subscription',
                    class_action: 'custom_api_change_ends_at',
                    id: activeDialog?.id,
                    new_ends_at: DateTime.fromFormat(newEnds, "dd/LL/y t").toUTC().toFormat("dd/LL/y t")
                  }
                });
              }}
              sx={{width: '100%', marginTop: 1}}
            />
          </Grid>
        </>}
        {!!activeDialog?.approved_at && <>
          <Grid item xs={12}>
            <Divider />
            <Button
              label={t("coach.models.knowledge_subscriptions.delete_subscription")}
              id='delete_subscription'
              disabled={mutationCustomAction.isPending}
              contained
              secondary
              startIcon={<Delete />}
              onClick={(v) => {
                mutationDestroy.mutate({
                  formData: {
                    object: 'knowledge_subscription',
                    id: activeDialog?.id,
                    ob: {
                      id: activeDialog?.id,
                    }
                  }
                });
              }}
              sx={{width: '100%', marginTop: 1}}
            />
          </Grid>
        </>}


        {!activeDialog?.approved_at && <>
          {activeDialog?.knowledge_course?.mollie_data?.immediate_payment?.toString() === '1'  && <Grid item xs={12}>
            <Alert severity='info'>
              <Typography>{t("coach.models.knowledge_subscriptions.warning.approve_after_payment")}</Typography>
            </Alert>
          </Grid>}
          <Grid item xs={12}>
            {!flickerEditor && <Editor
              simple
              label={t("coach.models.knowledge_subscription_approval.message")}
              value={approvalMessage || ""}
              onChange={(e) => {
                setApprovalMessage(e);
              }}
            />}
          </Grid>
          <Grid item xs={6}>
            <Button
              label={t("coach.models.knowledge_subscriptions.do_approve")}
              id='do_approve'
              disabled={mutationCustomAction.isPending}
              contained
              startIcon={<Check />}
              onClick={(v) => {
                mutationCustomAction2.mutate({
                  formData: {
                    object: 'knowledge_subscription',
                    class_action: 'custom_api_do_approve',
                    id: activeDialog?.id,
                    approve: 1,
                    message: approvalMessage,
                  }
                });
              }}
              sx={{width: '100%', marginTop: 1}}
            />
          </Grid>
          <Grid item xs={6}>
            <Button
              label={t("coach.models.knowledge_subscriptions.do_disapprove")}
              id='do_disapprove'
              disabled={mutationCustomAction.isPending}
              contained
              secondary
              startIcon={<Close />}
              onClick={(v) => {
                mutationCustomAction2.mutate({
                  formData: {
                    object: 'knowledge_subscription',
                    class_action: 'custom_api_do_approve',
                    id: activeDialog?.id,
                    disapprove: 1,
                    message: approvalMessage,
                  }
                });
              }}
              sx={{width: '100%', marginTop: 1}}
            />
          </Grid>
        </>}
      </Grid>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Btn autoFocus onClick={() => {setDialogOpen(false);}}>{t("coach.general.actions.cancel")}</Btn>
      </DialogActions>}
      open={dialogOpen}
      setOpen={setDialogOpen}
    />

    <Base
      name="progress"
      hidden={!showProgress}
      title={t("coach.dialogs.knowledge_progress.title")}
      content={<Grid container spacing={1}>
        {(showProgress?.progress?.progress || []).map((line:any) => <Grid item xs={12}>
          <Typography sx={{
            paddingLeft: line[0],
            borderLeft: `${8 * line[0]}px solid transparent`,
            borderColor: theme.palette.primary.main,
            ...(!line[2] && line[0] > 0 ? {
              color: 'lightgrey'
            } : {})
          }}>{selectContentWithId(line[1] || {})}</Typography>
        </Grid>)}
      </Grid>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Btn autoFocus onClick={() => {setShowProgress(undefined);}}>{t("coach.general.actions.cancel")}</Btn>
      </DialogActions>}
      open={!!showProgress}
      setOpen={(b) => {
        setShowProgress(!!b ? showProgress : undefined);
      }}
    />

    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
  </Page>;
}
